import { Component, Input, Output, EventEmitter, ElementRef, ViewChild } from '@angular/core';
import { forkJoin } from 'rxjs';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { StateService, AuthService } from '../../../services';
import { } from '../../../models';
import { AuctionLotSearchFilterItemTextModel } from '../../models';
import { FormFunctions } from '../../../functions';
import { Validations } from '../../../constants'

@Component({
    selector: 'modal-search-filter-item-text',
    templateUrl: 'modal-search-filter-item-text.component.html'
})
export class ModalSearchFilterItemTextComponent {
    processing: boolean = false;
    error: boolean = false;
    errorMessage: string = "";

    @Input() model: AuctionLotSearchFilterItemTextModel;

    @Output() apply: EventEmitter<string> = new EventEmitter();

    @ViewChild("txt", { read: ElementRef }) txt: ElementRef;

    constructor(public activeModal: NgbActiveModal, public stateService: StateService, public validations: Validations, public formFunctions: FormFunctions, public authService: AuthService) {
        let me = this;
    }
    ngOnInit() {
        let me = this;
        setTimeout(() => { me.txt?.nativeElement.select(); }, 0); // focus on the text box when the modal opens
    }
    Save(form) {
        var me = this;

        // console.log('Save', form);

        me.apply.emit(this.model.value);
        me.activeModal.close();
    }

    Close(evt) {
        var me = this;
        me.activeModal.close(null);
    }

    keyPress($event) {
        let me = this;
        if (me.model.regex) {
            return /^[0-9\-,]*$/i.test($event.key)
        }
    }
}